export const orderArray = (arr) => {
  const arrSort = arr.sort(
    (p1, p2) => (p1.x > p2.x) ? 1 : (p1.x < p2.x) ? -1 : 0)
  return arrSort
}
